import {
  Badge,
  Table,
  TableBody,
  TableCell,
  TableRow,
  useTableContext,
} from "@bleu.builders/ui";
import { MinusCircledIcon, PlusCircledIcon } from "@radix-ui/react-icons";
import React from "react";

import { cn } from "#/lib/utils";

import { ThesisItem } from "./ThesesItem";

export function isRecentlyCreated(date) {
  const publishedDate = new Date(date);
  const currentDate = new Date();
  const oneMonthAgo = new Date(
    currentDate.setMonth(currentDate.getMonth() - 1),
  );

  return publishedDate >= oneMonthAgo;
}

function RecentlyCreatedCount({ rows }) {
  const count = rows.filter(
    (row) =>
      isRecentlyCreated(row.original.published_at) && !row.original.archived,
  )?.length;

  const text = count === 1 ? "1 Tese nova" : `${count} Teses novas`;

  return count == 0 ? null : (
    <Badge className="bg-green-600/50 hover:bg-green-600/40">{text}</Badge>
  );
}

function MappedCount({ row }) {
  const count = row.getLeafRows()?.length;

  const text = count === 1 ? "1 Tese Mapeada" : `${count} Teses Mapeadas`;

  return count == 0 ? null : (
    <Badge className="bg-green-600/50 hover:bg-green-600/40">{text}</Badge>
  );
}

export function ThesesTableBody({
  showRecentlyCreated = true,
  showOpportunitiesCount = false,
  defaultOpen = false,
}) {
  // @ts-expect-error TS(2339) FIXME: Property 'table' does not exist on type 'unknown'.
  const { table, isLoading } = useTableContext();

  if (isLoading) {
    return (
      <div className="space-y-4 size-full overflow-y-auto max-h-[80vh] min-h-[10vh] animate-pulse text-muted-foreground">
        Carregando...
      </div>
    );
  }

  return (
    <div className="rounded-md">
      <Table className="border-0">
        <TableBody className="rounded-md flex gap-3 flex-col">
          {table.getRowModel().rows?.length ? (
            table.getRowModel().rows.map((row, index) =>
              row.getIsGrouped() ? (
                <div className="flex gap-2 flex-col">
                  <button
                    key={row.id}
                    className={cn(
                      "flex items-center bg-muted border dark:border-2 p-2 rounded-lg text-xl",
                      {
                        "mx-0": row.getIsExpanded(),
                      },
                    )}
                    onClick={row.getToggleExpandedHandler()}
                  >
                    <div className="ml-2">
                      {row.getIsExpanded() ? (
                        <MinusCircledIcon className="text-primary size-4 font-bold" />
                      ) : (
                        <PlusCircledIcon className="text-primary size-4 font-bold" />
                      )}
                    </div>
                    <span
                      className={cn(
                        "flex items-center text-foreground p-2 rounded-md font-medium gap-2 select-text",
                        {
                          "text-primary": row.getIsExpanded(),
                        },
                      )}
                    >
                      {row.groupingValue}
                      {showOpportunitiesCount && <MappedCount row={row} />}
                    </span>
                    <div className="flex items-center gap-3">
                      {showRecentlyCreated && (
                        <RecentlyCreatedCount rows={row.getLeafRows()} />
                      )}
                    </div>
                  </button>
                  {row.getIsExpanded() ? (
                    <div className="flex gap-2 flex-col ml-4">
                      {row.getLeafRows()?.map((subRow, leafIndex) => (
                        <ThesisItem
                          key={subRow.id}
                          row={subRow}
                          index={leafIndex}
                          parentRowIndex={index}
                          defaultOpen={defaultOpen}
                        />
                      ))}
                    </div>
                  ) : null}
                </div>
              ) : null,
            )
          ) : (
            <TableRow className="rounded-md">
              <TableCell
                colSpan={table.getAllColumns().length}
                className="py-10 text-center text-sm text-muted-foreground"
              >
                Nenhum resultado encontrado.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
